// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".command_wrapper[data-v-65b7de20]{display:flex;margin:0 0 10px 0;padding:5px 10px;cursor:pointer;background-color:var(--el-color-primary-light-9);.name[data-v-65b7de20]{font-weight:700;min-width:200px}.command[data-v-65b7de20]{flex-grow:1;margin-left:20px;color:var(--el-text-color-secondary)}}", ""]);
// Exports
module.exports = exports;
